import React from 'react'
import { AttachmentData } from '../../../../../../../../@types/types'
import uploadedDocumentImage from './uploaded_document.svg'
import styles from '../AttachmentsList.module.css'
import TitleLabel from '../common/TitleLabel'
import Options from '../common/Options'
import { useMultimediaDetailsModalContext } from '../../multimediaDetailsModalContext/multimediaModalsContext'

export const Document: React.FC<{
  data: AttachmentData
  index: number
  screenId: string
}> = (props) => {
  const { openModalForAttachmentIndex } = useMultimediaDetailsModalContext()

  return (
    <div className='grid-item one-half'>
      <div
        className={`${styles.attachmentContainer} padding-l align-center border-radius-rounded cursor-pointer`}
        aria-label={props.data.attachment?.title || ''}
        onClick={() => openModalForAttachmentIndex(props.index)}
      >
        <img src={uploadedDocumentImage} alt='PDF' className='margin-top-m' />
        <TitleLabel title={props.data.attachment?.title} />
        <Options />
      </div>
    </div>
  )
}

export default Document
